import { liveBind, Emitter } from 'evite'
import { AuthModal } from '../modal/index'
import urls from 'urls';

class SignInView extends Emitter {

    user =  null;
    signed_in = false;

    constructor () {
        super();
        this.el = document.getElementById('header');
        this.signed_in = this.check_signed_in();
        this.bindEvents();
    };

    bindEvents() {
        liveBind(this.el, 'click', '#signin_button', this.sign_in);
        liveBind(this.el, 'click', '#signout_button', this.sign_out);
        liveBind(this.el, 'click', '#register_button', this.register);
    };

    get_user () {
        // evite_cookie = window.evite.cookie('x-evite-auth')
        // evite_cookie && evite_cookie.split(':')[0]
        // doh, the auth cookie changed and we need some way to keep this functionality
        return window.tags.dl.email;
    };

    check_signed_in () {
        let r = 0;
        try {
            r = window.tags.dl.is_logged_in === 1;
        }
        finally {
            return r;
        }
    };

    get_next () {
        // for sign in and register, return the 'next' param if appropriate
        if (window.location.protocol === 'https:') {
            return getURLParameter('next');
        }

        if (!window.location.pathname.match(/(login|register).*/)) {
            let n = window.location.pathname;
            if (window.location.search) {
                n +=window.location.search;
            }
            return n;
        }
        return null;
    };

    sign_in (callback, next) {
        if (!next) {
            next = null;
        }
        if (typeof callback !== 'function') {
            callback = null;
        }
        if (callback === null) {
            next = next || (this.get_next() || '');
            if (next) {
                next = '?next=' + encodeURIComponent(next);
            }
            window.location.href = urls.get('login') + next;
            return;
        }
        let sign_in_modal = new AuthModal({
            onLogin: (r) => {
                window.tags.track_event('on_login');
                if (callback != null) {
                    this.set_signed_in_state(r.full_name);
                    return callback();
                } else {
                    return this.set_signed_in(r.full_name);
                }
            },
            onCancel: () => {
                return this.dispatchEvent(new CustomEvent('cancel'));
            }
        });
        return sign_in_modal.show();
    };

    register (callback, next) {
        let register_modal;
        if (!next) {
            next = null;
        }
        if (typeof callback !== 'function') {
            callback = null;
        }
        if (callback === null) {
            next = next || (this.get_next() || '');
            if (next) {
                next = '?next=' + encodeURIComponent(next);
            }
            window.location.href = urls.get('register') + next;
            return;
        }
        register_modal = new AuthModal({
            url: urls.get('register_modal'),
            onLogin: (d) =>  {
                return this.set_signed_in(d.full_name);
            }
        });
        return register_modal.show();
    };

    sign_out () {
        window.tags.page_event('signout_button');
        window.evite.fetch(urls.get('ajax_logout'), {
            method: "post",
            credentials: 'include',
            headers: {
                "X-CSRFToken": evite.cookie("csrftoken"),
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        }).then((response) => {
            return window.location.assign(urls.get('login'));
        }).catch((error) => {
            evite.error("Error while posting to " + url + " errorThrown=" + error);
        });
    };

    set_signed_in_state (full_name) {
        const loggedIn = document.querySelector('.logged_in');
        const signedIn = document.querySelector('.signed_in');
        const loggedOut = document.querySelector('.logged_out');
        const signedOut = document.querySelector('.signed_out');
        const signIn = document.querySelector('.signin');
        const name = document.querySelector('li.user .full_name');
        if (loggedIn) loggedIn.style.display = 'block';
        if (signedIn) loggedIn.style.display = 'block';
        if (loggedOut) loggedIn.style.display = 'none';
        if (signedOut) loggedIn.style.display = 'none';
        if (signIn) loggedIn.style.display = 'none';
        this.signed_in = true;
        this.user = full_name;
        if (name) name.innerHTML = full_name;
        return this.dispatchEvent(new CustomEvent('success'));
    };

    set_signed_in (full_name) {
        if (!window.prevent_page_reload_on_login) {
            return window.location.reload();
        } else {
            return this.set_signed_in_state(full_name);
        }
    };

    facebook_connect (opts) {
        window.tags.page_event('facebook_connect');

        let w = 580;
        let h = 400;
        let left = (screen.width / 2) - (w / 2);
        let top = (screen.height / 2) - (h / 2);
        let popup = window.open(urls.get('facebook_connect'), 'fb_auth', "width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
        if (popup == null) {
            if (!window.prevent_page_reload_on_login) {
                window.location.assign('/login/?next=' + encodeURIComponent(window.location.pathname));
            } else {
                alert("We tried to open a popup window to connect to Facebook. Please enable popup windows in your browser.");
            }
            return;
        }

        let check_connected = () => {
            if (popup.closed) {
                let url = urls.get('ajax_authenticated');
                window.evite.fetch(url, {
                    credentials: 'include',
                    headers: {
                        "X-CSRFToken": evite.cookie("csrftoken"),
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    }
                }).then((response) => {
                    return response.json()
                }).then(data => {
                    if (data && data.full_name) {
                        this.set_signed_in(data.full_name);
                        if (opts.onConnect) {
                            return opts.onConnect(data.full_name);
                        }
                    }
                }).catch((error) => {
                    window.console.log("Error while posting to " + url + " errorThrown=" + error);
                })

            } else {
                return setTimeout(check_connected, 300);
            }
        };

        return check_connected();
    };

    google_plus_connect (opts) {
        window.tags.page_event('google_plus_connect');

        let w = 580;
        let h = 400;
        let left = (screen.width / 2) - (w / 2);
        let top = (screen.height / 2) - (h / 2);
        let popup = window.open(urls.get('google_plus_connect'), 'gp_auth', "width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
        if (popup == null) {
            if (!window.prevent_page_reload_on_login) {
                window.location.assign('/login/?next=' + encodeURIComponent(window.location.pathname));
            } else {
                alert("We tried to open a popup window to connect to Google Plus. Please enable popup windows in your browser.");
            }
            return;
        }

        let check_connected = () => {
            if (popup.closed) {
                window.evite.fetch(urls.get('ajax_authenticated'), {
                    credentials: 'include',
                    headers: {
                        "X-CSRFToken": evite.cookie("csrftoken"),
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    }
                }).then((response) => {
                    return response.json()
                }).then(data => {
                    if (data && data.full_name) {
                        this.set_signed_in(data.full_name);
                        if (opts.onConnect) {
                            opts.onConnect(data.full_name);
                        }
                    }
                }).catch((error) => {
                    if (window.console !== null) {
                        console.log(`error: ${error}`);
                    }
                });
            } else {
                return setTimeout(check_connected, 300);
            }
        };

        return check_connected();
    };

};

export default SignInView



// WEBPACK FOOTER //
// ./assets/es6/nav/sign_in_out.es6